<template>
  <v-container class="chair-amount-form pt-0 pb-1">
    <div class="d-flex flex-column flex-sm-row justify-end">
      <v-btn
        outlined
        class="toggle-button"
        @click="toggleForm()"
      >Update chair amount</v-btn>
    </div>

    <v-card
      v-if="showForm"
      :class="{ 'mt-2': amounts?.length }"
    >
      <v-card-text>
        <v-row
          v-for="(row, index) in amounts"
          :key="index"
          align="center"
        >
          <v-col
            cols="12"
            sm="4"
            md="3"
            class="pt-0 pb-0"
          >
            <v-menu
              v-model="row.startMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="row.start"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  class="input"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="row.start"
                @input="row.startMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="4"
            md="3"
            class="pt-0 pb-0"
          >
            <v-menu
              v-model="row.endMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="row.end"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="row.end"
                @input="row.endMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="3"
            class="pt-0 pb-0"
          >
            <v-text-field
              v-model="row.amount"
              label="Chair amount"
              type="number"
              min="1"
              :rules="[v => !!v || 'Chair amount is required', v => v > 0 || 'Must be larger than 0']"
              required
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
            class="buttons"
          >
            <v-btn
              icon
              color="#143b55"
              class="icon-delete"
              @click="remove(index)"
              v-if="amounts.length > 1"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          text
          color="primary"
          @click="closeForm"
        >
          Close
        </v-btn>
        <v-btn
          outlined
          color="primary"
          @click="addRow"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import DataService from '../../../_services/DataService';

export default {
  data() {
    return {
      showForm: false,
      saving: false,
      id: null,
      amounts: [
        {
          start: null,
          end: null,
          amount: null,
          startMenu: false,
          endMenu: false,
        },
      ],
    };
  },

  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
    },
    closeForm() {
      this.showForm = false;
    },
    addRow() {
      this.amounts.push({
        start: null,
        end: null,
        amount: null,
        startMenu: false,
        endMenu: false,
      });
    },
    async remove(index) {
      this.amounts.splice(index, 1);
    },
    async save() {
      this.saving = true;

      const res = await DataService.saveChairAmounts({
        id: this.id,
        amounts: this.amounts,
      });

      if (res.status === 200) {
        if (!this.id) {
          this.id = res.data.id;
        }

        this.$emit('change');
      }

      this.saving = false;
    },
  },
  async mounted() {
    const res = await DataService.getChairAmounts();

    this.id = res.data?.id;
    this.amounts = res.data?.amounts ?? [];
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/variables.scss';

.chair-amount-form {
  padding: 0 4px;

  @media (max-width: $breakpoint-tablet) {
    padding: 0 12px;
  }

  .toggle-button {
    text-transform: none;
  }
}

.buttons {
  display: flex;

  @media (max-width: $breakpoint-tablet) {
    justify-content: end;
  }
}

.icon-delete {
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}
</style>
